import React, { useState } from "react";
import moment from "moment";
import EntityHeader from "./common/EntityHeader";
import ClientPayorCard from "./common/ClientPayorCard";
import ClientPayorModal from "./common/ClientPayorModal";
import {
  getFieldText,
  getFieldName,
  formatDate,
} from "./../scripts/helperScripts";

function ClientPayorEntity({
  clientPayors,
  clientId,
  clientProgram,
  showExpired,
  updateClientPayors,
  updateAddresses,
  addresses,
  careTeam,
  addressBeingCreated,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialData, setInitialData] = useState();

  const showModal = (payor) => {
    const obj = {
      ccx_clientpayorid: payor.ccx_clientpayorid,
      ccx_effdate: formatDate(getFieldText(payor.ccx_effdate)),
      ccx_expdate:
        payor.ccx_expdate && formatDate(getFieldText(payor.ccx_expdate)),
      ccx_payorrank: getFieldText(payor.ccx_payorrank),
      ccx_id1: payor.ccx_id1,
      ccx_id2: payor.ccx_id2,
      ccx_selfpolicyholder: getFieldText(payor.ccx_selfpolicyholder),
      ccx_familymember: getFieldText(payor.ccx_familymember),
      ccx_payor: getFieldText(payor.ccx_payor),
      ccx_payorgroupplan: getFieldText(payor.ccx_payorgroupplan),
      ccx_groupplanpayoraddress: getFieldText(payor.ccx_groupplanpayoraddress),
      ccx_contactaddress: getFieldText(payor.ccx_contactaddress),
      ccx_notes: payor.ccx_notes,
      payorName: getFieldName(payor.ccx_payor),
      payorGroupPlanName: getFieldName(payor.ccx_payorgroupplan),
      groupPlanAddressName: getFieldName(payor.ccx_groupplanpayoraddress),
    };
    setInitialData(obj);
    setIsOpen(true);
  };

  const hideModal = () => {
    setInitialData();
    setIsOpen(false);
  };

  const addNew = () => {
    setInitialData();
    setIsOpen(true);
  };

  return (
    <>
      {isOpen ? (
        <ClientPayorModal
          isOpen={isOpen}
          addNew={addNew}
          hideModal={hideModal}
          initialData={initialData}
          clientId={clientId}
          clientProgram={clientProgram}
          updateClientPayors={updateClientPayors}
          updateAddresses={updateAddresses}
          addresses={addresses.filter(
            (address) => getFieldName(address.ccx_addresstype) === "Home"
          )}
          careTeam={careTeam}
          addressBeingCreated={addressBeingCreated}
        ></ClientPayorModal>
      ) : null}
      <EntityHeader
        {...rest}
        title="Client Payors"
        add={addNew}
        clientId={clientId}
        body={
          clientPayors &&
          clientPayors.map((cp) => (
            <div
              className={
                cp.ccx_expdate !== undefined && !showExpired
                  ? "d-none p-2"
                  : "d-block p-2"
              }
              key={cp.ccx_clientpayorid}
            >
              <ClientPayorCard clientPayor={cp} onEdit={() => showModal(cp)} />
            </div>
          ))
        }
      />
    </>
  );
}

export default ClientPayorEntity;
